export default class InlineSvg extends HTMLElement {
  static get observedAttributes() {
    return ['src'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name !== 'src' || !newValue || newValue === oldValue) return;
    this._load(newValue);
  }

  connectedCallback() {
    const src = this.getAttribute('src');
    if (src) this._load(src);
  }

  _load(src) {
    if (this._fetched) return;
    this._fetched = true;
    fetch(src)
      .then(r => {
        if (!r.ok) throw new Error(`inline-svg 404: ${src}`);
        const type = r.headers.get('content-type') || '';
        if (type.startsWith('image/') && !type.includes('svg')) {
          const cls = this.getAttribute('class');
          const alt = this.getAttribute('aria-label') || this.getAttribute('alt') || '';
          const img = document.createElement('img');
          img.src = src;
          img.alt = alt;
          img.setAttribute('loading', 'lazy');
          img.setAttribute('role', 'decorative');
          if (cls) img.className = cls;
          this.replaceWith(img);
          return null;
        }
        return r.text();
      })
      .then(text => {
        if (text === null) return;

        const tpl = document.createElement('template');
        tpl.innerHTML = text.trim();
        const svg = tpl.content.querySelector('svg');
        if (!svg) throw new Error(`inline-svg: no <svg> root in ${src}`);

        const cls = this.getAttribute('class');
        if (cls) svg.setAttribute('class', cls);

        // Decorative by default, matching the icon set in src/icons. An
        // aria-label (or alt) on the host <inline-svg> overrides that and
        // labels the graphic instead. Never a tab stop, either way.
        svg.setAttribute('focusable', 'false');
        const label = this.getAttribute('aria-label') || this.getAttribute('alt');
        if (label) {
          svg.setAttribute('role', 'img');
          svg.setAttribute('aria-label', label);
          svg.removeAttribute('aria-hidden');
        } else {
          svg.setAttribute('aria-hidden', 'true');
          svg.removeAttribute('role');
          svg.removeAttribute('aria-label');
        }

        this.replaceWith(svg);
      })
      .catch(console.error);
  }
}
